import { BASE_URL } from '@/constants'
import { request } from 'graphql-request'

export const fetcherGraphQL = (query: string) =>
  request(`${BASE_URL}/graphql`, query)

export const fetcher = (query: string) => fetch(query).then(res => res.json())
